define([
    "./nlgScriptSqlQueryReportModule",
    "./nlgScriptSqlQueryReportService",
    "./nlgScriptSqlQueryReportDirective",
    "./list/nlgScriptSqlQueryReportListDirective",
    "./nlgScriptSqlFilterResultDirective"
], function () {

});